<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-two-thirds">
                        <div class="box whitebox">
                            <div class="columns is-vcentered">
                                <div class="column is-7 is-spaced">
                                    <img src="@/assets/logo.png" />
                                    <h4 class="subtitle">Gestão de projetos e relacionamento com o cliente</h4>
                                    <a class="button is-dark" href="/Account/Login">Google</a>
                                </div>
                                <div class="column is-spaced">
                                    <div v-if="erros.length > 0" class="notification is-danger">
                                        <ul>
                                            <li v-for="(erro, index) in erros" v-bind:key="index">
                                                {{ erro }}
                                            </li>
                                        </ul>                                        
                                    </div>
                                    <form @submit.prevent="onSubmit" method="post" role="form">
                                        <div class="field is-marginless">
                                            <b-field label="E-mail">
                                                <b-input placeholder="Email"
                                                         v-model="UserName"
                                                         type="email"
                                                         icon="email">
                                                </b-input>
                                            </b-field>
                                        </div>
                                        <b-field label="Senha">
                                            <b-input placeholder="Senha"
                                                     v-model="Password"
                                                     type="password"
                                                     icon="lock">
                                            </b-input>
                                        </b-field>
                                        <button type="submit" class="button is-primary is-fullwidth">Entrar</button>
                                        <div class="level">
                                            <div class="level-right">
                                                <div class="level-item is-size-7">
                                                    <a href="#">Esqueceu a senha?</a>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="has-text-centered is-italic">desenvolvido por <a href="http://www.sysplan.com.br">Sysplan</a></p>
            </div>            
        </div>
    </section>
</template>

<style scoped>
.is-spaced {
    padding: 1.5em;
}
</style>

<script>
    import { mapActions, mapState } from 'vuex'

    export default {
        data() {
            return {
                UserName: '',
                Password: ''
            }
        },
        computed: {
            ...mapState([
                'config',
                'erros'
            ])
        },
        methods: {
            ...mapActions([
                'login'
            ]),
            onSubmit() {
                this.login({ UserName: this.UserName, Password: this.Password })
            }
        }
    }
</script>